export default __webpack_public_path__ + "static/underline-23-784254bdc9d0116ddb625ae34939795e.svg";